import { createSlice } from '@reduxjs/toolkit'
import {
  AUTO,
  BICYCLE,
  FREIGHT,
  PEDESTRIAN,
  TRANSIT
} from '../../constants/modalTiers'

const initialState = {
  prioritiesDictionary: [
    { id: 1, tier: PEDESTRIAN, text: 'People Walking', modalTier: 0 },
    { id: 2, tier: BICYCLE, text: 'People Biking', modalTier: 0 },
    { id: 3, tier: TRANSIT, text: 'People Riding Transit', modalTier: 0 },
    { id: 4, tier: AUTO, text: 'People Driving', modalTier: 0 },
    { id: 5, tier: FREIGHT, text: 'People Moving Freight', modalTier: 0 }
  ]
}

const modalPrioritiesCardDict = createSlice({
  name: 'modalPrioritiesCardDict',
  initialState,
  reducers: {
    setPrioritiesDictionary(state, action) {
      const { field, value } = action.payload
      state[field] = value
    },
    resetPrioritiesDictionary(state) {
      return initialState
    }
  }
})

export const { setPrioritiesDictionary, resetPrioritiesDictionary } =
  modalPrioritiesCardDict.actions
export default modalPrioritiesCardDict.reducer
